/* Vendored shadcn/ui. Edits limited to token/density wiring (111 §2). */
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export function PopoverContent({
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 w-72 rounded-lg border border-[var(--border)] bg-[var(--popover)] p-2 text-[var(--popover-foreground)] shadow-md outline-none',
          'text-[length:var(--ui-font)]',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
